module.exports = __webpack_public_path__ + "img/storage.efb9325e.png";